document.addEventListener('DOMContentLoaded', function () {
  function animate_blog_index() {
    const items = document.querySelectorAll('.blog-index-item.reveal');
    items.forEach((item, idx) => {
      if (!item.classList.contains('revealed')) {
        setTimeout(() => {
          item.classList.add('revealed');
        }, idx * 100);
      }
    });
  }
  if (typeof load_more_ajax === 'undefined') return;
  let {
    url,
    ajaxurl,
    posts,
    current_page,
    max_page,
    category_name,
    load_more_label,
    previous_template,
    next_template,
  } = load_more_ajax;

  animate_blog_index();

  document.querySelector('.search-field').addEventListener('blur', function () {
    current_page = 0;
    document.querySelector('.blog-index').innerHTML = '';
    animate_blog_index();
    loadMore();
    //store the value of the select fields in the local storage
    localStorage.setItem(`search-field`, this.value);
  });

  document
    .querySelector('.blog-filter-clear')
    .addEventListener('click', function () {
      // empty the local storage filters
      localStorage.removeItem('filter-assembly');
      localStorage.removeItem('filter-brand');
      localStorage.removeItem(`search-field`);
      document.querySelectorAll('.blog-filter').forEach((filter) => {
        filter.value = '';
      });
      document.querySelector('.search-field').value = '';
      current_page = 0;
      document.querySelector('.blog-index').innerHTML = '';
      animate_blog_index();
      loadMore();
    });

  document.querySelectorAll('.blog-filter').forEach((filter) => {
    filter.addEventListener('change', function (e) {
      current_page = 0;
      document.querySelector('.blog-index').innerHTML = '';
      animate_blog_index();
      loadMore();
      //store the value of the select fields in the local storage
      localStorage.setItem(`filter-${e.target.name}`, this.value);
    });
  });

  // on page load set the value of the select fields to the value stored in the local storage
  document.querySelectorAll('.blog-filter').forEach((filter) => {
    filter.value = localStorage.getItem(`filter-${filter.name}`) || '';
    if (category_name && filter) {
      const option = filter.querySelector(`option[value="${category_name}"]`);
      if (option) {
        filter.value = category_name;
      }
    }
  });
  document.querySelector('.search-field').value =
    localStorage.getItem(`search-field`) || '';

  const no_more_results = document.createElement('div');
  no_more_results.classList.add('no-more-results');
  no_more_results.innerText = ''; // No more results. Try refining your search terms.
  no_more_results.style.display = 'none';
  document.querySelector('.blog-load-more').appendChild(no_more_results);

  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = 'Load More';

  document.querySelector('.blog-load-more').appendChild(button);
  if (max_page == 1) {
    no_more_results.style.display = 'block';
    button.style.display = 'none';
  }
  function loadMore() {
    button.disabled = true;
    button.textContent = 'Loading...';

    const data = new FormData();
    data.append('action', 'blog-load-more');
    data.append('query', posts);
    data.append('page', current_page);
    data.append('search-field', document.querySelector('.search-field').value);
    data.append(
      'assembly',
      document.querySelector('.blog-filter[name="assembly"]').value
    );
    data.append(
      'brand',
      document.querySelector('.blog-filter[name="brand"]').value
    );

    fetch(ajaxurl, {
      method: 'POST',
      body: data,
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (result) {
        if (result) {
          button.textContent = 'Load More';
          button.disabled = false;

          const obj = JSON.parse(result);
          let navPagination = obj.pagination.replaceAll(
            'href="http://',
            'href='
          );
          navPagination = navPagination.replaceAll('href="https://', 'href=');
          navPagination = navPagination.replaceAll('href=', `href="${url}/`);
          max_page = obj.max_page;

          document
            .querySelector('.blog-index')
            .insertAdjacentHTML('beforeend', obj.content);
          animate_blog_index();

          current_page++;

          if (current_page >= max_page) {
            button.style.display = 'none';
            no_more_results.style.display = 'block';
          } else {
            button.style.display = 'block';
            no_more_results.style.display = 'none';
          }
        } else {
          button.style.display = 'none';
          no_more_results.style.display = 'block';
        }
      });
  }

  document
    .querySelector('.blog-load-more')
    .addEventListener('click', function (event) {
      if (event.target.tagName === 'BUTTON') {
        loadMore();
      }
    });
});
